import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  background-color: ${props => props.backgroundColor};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp16} ${props.theme.spacing.sp16}`};
  cursor: pointer;
`

export const IdentifierContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.sp16};
  padding-left: 0px;
  color: ${props => props.theme.colors.text.subtle};
  border-right: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  margin-right: ${props => props.theme.spacing.sp16};
  min-width: 50px;
`

export const InfoContainer = styled.div`
  width: calc(100% - 5.25rem);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NameContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const Name = styled.div`
  display: flex;
  margin-left: -24px;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;

  > div {
    display: inline-flex !important;
  }

  label {
    color: ${props => (props.isEnabled ? props.theme.colors.text.default : props.theme.colors.text.subtle)};
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const DetailText = styled.div`
  color: ${props => (props.isEnabled ? 'inherit' : props.theme.colors.text.subtle)};
`
